import { gql } from 'apollo-angular';

export const CO_BROWSING_COMPANY_AUTO_SUGGESTION = gql`
  query companyLookup($searchText: String!) {
    companyLookup(searchText: $searchText) {
      data {
        companyName
        id
        companyId
        __typename
      }
      isSuccess
      message
      errorCode
      __typename
    }
  }
`;
